import { Popover } from 'antd';
import React, { useEffect, useState } from 'react';

import { FilterTableParamType, FilterType, StructureTableFieldType, TableFilterType } from '../types';
import { getDefaultListFilter } from './functions';
import TableConditionForm from './TableConditionForm';

interface ITableListFilter {
    filterItem: TableFilterType;
    typeField: StructureTableFieldType;
    children: React.JSX.Element;
    paramFilter?: FilterTableParamType;
}

const TableListFilter: React.FC<ITableListFilter> = ({ filterItem, typeField, children, paramFilter }) => {
    const [open, setOpen] = useState<boolean>(false);
    const [currentTableFilter, setCurrentTableFilter] = useState<FilterType[]>([]);

    useEffect(() => {
        const defaultFilterList = getDefaultListFilter(typeField);

        const filterParams = paramFilter?.[filterItem.option.key];

        const extraFilterList: FilterType[] = filterParams?.filterComponent
            ? [
                  {
                      type: 'from_list',
                      requiredInput: true,
                      inputType: 'List',
                      filterParams,
                  },
              ]
            : [];

        const newCurrentTableFilter = extraFilterList.concat(defaultFilterList);

        const availableTypeFilter = new Set(filterParams?.availableTypeFilter || []);

        setCurrentTableFilter(
            newCurrentTableFilter.filter(
                (tableFilter) => !availableTypeFilter.size || availableTypeFilter.has(tableFilter.type),
            ),
        );
    }, [typeField]);

    const content = (
        <TableConditionForm
            currentTableFilter={currentTableFilter}
            filterItem={filterItem}
            setOpen={setOpen}
            typeField={typeField}
        />
    );

    return (
        <Popover
            key={open ? '' : 'uuidv4()'}
            content={content}
            placement="bottomLeft"
            // style={{ width: 150 }}
            trigger={'click'}
            open={open}
            onOpenChange={(visible) => setOpen(visible)}
        >
            {children}
        </Popover>
    );
};

export default TableListFilter;
